export enum PackageRepositoryMeta {
  MODEL = "packagerepository",
  PK = "id",
}
